document.addEventListener('alpine:init', () => {
    Alpine.data('orderLookup', () => ({
        orderId: '',
        billingPhone: '',
        isLoading: false,
        order: null,
        errorMessage: '',
        init() {
            const urlParams = new URLSearchParams(window.location.search);
            const orderIdParam = urlParams.get('order_id');
            const billingPhoneParam = urlParams.get('billing_phone');

            if (orderIdParam) {
                this.orderId = orderIdParam;
                if (billingPhoneParam) {
                    this.billingPhone = billingPhoneParam;
                }
                this.lookupOrder();
            }

            if (wooli_data.helpers.recaptchaEnable) {
                waitForRecaptcha();
            }
        },

        reset() {
            this.orderId = '';
            this.billingPhone = '';
            this.isLoading = false;
            this.order = null;
            this.errorMessage = '';
        },
        

        async lookupOrder() {
            if (this.orderId.trim() === '') {
                this.errorMessage = orderLookup.translations.invalid_order_id;
                this.order = null;
                return;
            }

            if (this.isPhoneRequired && this.billingPhone.trim() === '') {
                this.errorMessage = orderLookup.translations.invalid_phone;
                this.order = null;
                return;
            }

            this.isLoading = true;
            this.errorMessage = '';
            this.order = null;
            this.$refs.buttonText.classList.add('hidden');
            if (this.$refs.loadingSpinner) {
                this.$refs.loadingSpinner.classList.remove('hidden');
            }
            try {

                const captcha = await checkCaptcha('order_lookup');

                const response = await fetch(orderLookup.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                    body: new URLSearchParams({
                        action: 'lookup_order',
                        order_id: this.orderId,
                        billing_phone: this.billingPhone,
                        require_phone: this.isPhoneRequired ? 'yes' : 'no',
                        nonce: orderLookup.nonce,
                        ...(wooli_data.helpers.recaptchaEnable && { captcha })
                    }),
                });

                const data = await response.json();

                if (data.success) {
                    this.order = data.data.order;
                } else {
                    this.errorMessage = data.data.message || orderLookup.translations.order_not_found;
                }
            } catch (error) {
                this.errorMessage = orderLookup.translations.error_occurred;
            } finally {
                this.isLoading = false;
                if (this.$refs.buttonText) {
                    this.$refs.buttonText.classList.remove('hidden');
                }

                if (this.$refs.loadingSpinner) {
                    this.$refs.loadingSpinner.classList.add('hidden');
                }
            }
        },

        get isPhoneRequired() {
            // Kiểm tra nếu trường số điện thoại tồn tại
            return document.getElementById('billing_phone') !== null;
        },
        
    }));
});


let recaptchaReady = false;

const waitForRecaptcha = function () {
    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.ready === 'function') {
        grecaptcha.ready(() => {
            recaptchaReady = true;
            // console.log('reCAPTCHA v3 ready');
        });
    } else {
        setTimeout(waitForRecaptcha, 100);
    }
};

const checkCaptcha = function (action) {
    return new Promise((resolve, reject) => {
        if (!wooli_data.helpers.recaptchaEnable) {
            resolve('');
            return;
        }
        if (!recaptchaReady) {
            Swal.fire({
                icon: 'error',
                title: `<span class="swal-title-custom">${wooli_data.translations.captchaNotLoaded}</span>`,
                customClass: {
                    popup: 'login-popup',
                    confirmButton: 'swal-confirm-btn',
                    cancelButton: 'swal-cancel-btn'
                },
            });
            reject(new Error('reCAPTCHA not ready'));
            return;
        }
        grecaptcha.execute(wooli_data.helpers.recaptchaSiteKey, { action: action })
            .then(function (token) {
                if (!token) {
                    Swal.fire({
                        icon: 'error',
                        title: `<span class="swal-title-custom">${wooli_data.translations.captchaRequired}</span>`,
                        customClass: {
                            popup: 'login-popup',
                            confirmButton: 'swal-confirm-btn',
                            cancelButton: 'swal-cancel-btn'
                        },
                    });
                    reject(new Error('No reCAPTCHA token'));
                } else {
                    resolve(token);
                }
            })
            .catch(error => {
                console.error('reCAPTCHA execute error:', error);
                if (error.message.includes('score') || error.message.includes('clients')) {
                    renderRecaptchaV2(action).then(resolve).catch(reject);
                } else {
                    reject(error);
                }
            });
    });
};

const renderRecaptchaV2 = function (action) {
    return new Promise((resolve, reject) => {
        const containerId = `${action}-captcha-container`;
        let $container = $(`#${containerId}`);
        if (!$container.length) {
            $container = $('<div>').attr('id', containerId).appendTo('body').addClass('hidden');
        }
        $container.removeClass('hidden');
        const widgetId = grecaptcha.render(containerId, {
            sitekey: wooli_data.helpers.recaptchaSiteKey,
            callback: function (token) {
                $container.addClass('hidden');
                resolve(token);
            },
            'error-callback': function () {
                reject(new Error('reCAPTCHA v2 failed'));
            }
        });
    });
};
